module.exports = __webpack_public_path__ + "static/media/about22.395c2ad4.webp";